// src/lib/usinasVigor.ts
//
// Usinas da Vigor por número normalizado (só dígitos, sem zeros à esquerda), pelo número
// longo E pelo curto. Vem de usinas_vigor_numeros(), a mesma lista que o gatilho
// trg_validar_pulo_calculo usa: tela e banco não discordam.
//
// Comparar só o número longo erra: há contas que trazem o curto (ex.: 10036788990, Vera
// Cruz 03), e essa usina passava por "não é da Vigor".
//
// Cache de módulo: a lista muda uma vez por trimestre. Falha não fica em cache.

import { supabase } from './supabase';
import type { UsinasVigor } from './pularCalculoInjecao';

let cache: Promise<UsinasVigor | null> | null = null;

async function buscar(): Promise<UsinasVigor | null> {
  const { data, error } = await supabase.rpc('usinas_vigor_numeros');
  if (error) {
    console.warn('[usinas-vigor] não foi possível carregar a lista:', error.message);
    return null;
  }
  const mapa = new Map<string, string>();
  for (const l of (data || []) as { numero: string | null; nome: string | null }[]) {
    if (l.numero) mapa.set(l.numero, l.nome || 'Usina da Vigor');
  }
  // Lista vazia é o mesmo que não saber (papel sem acesso, cadastro vazio).
  return mapa.size ? mapa : null;
}

/** `null` quando não deu para saber. Quem usa decide: o pulo de cálculo bloqueia. */
export function carregarUsinasVigor(): Promise<UsinasVigor | null> {
  if (!cache) {
    cache = buscar()
      .catch(() => null)
      .then((r) => {
        if (!r) cache = null;
        return r;
      });
  }
  return cache;
}
